/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import CustomTable from "../../../../components/table/CustomTable";
import EmployeeDocsTableApp from "./Functionality/EmployeeDocsTableApp";
import {permissionObj} from "../../../../Helpers/permission";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";

const EmployeeDocsTab = ({selectDocForDelete, setSelectDocForDelete, isAllChecked, modified, setModified, setIsAllChecked, handleAction}) => {
    const {DEV, permission, tableId, searchId, thead, tbody, getActionsButtons, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        option,
        simpleSearch,
        setSimpleSearch,
        setSearch
    } = EmployeeDocsTableApp({
        setSelectedList:setSelectDocForDelete,
        modified,
        setModified,
        setIsAllChecked,
        handleAction
    });

    return (
        <>
            <div className={"col-12 p-0"}>
                <SearchSimple
                    id={searchId}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={null}
                    supplierId={null}
                />
            </div>
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_DELETE)}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectDocForDelete}
            />

            { pagination() }
        </>
    );
};

export default EmployeeDocsTab;
